/* K Junction – new side cart (replaces the theme mini cart everywhere) */
(function () {
  'use strict';
  var D = document.querySelector('[data-kjd]');
  if (!D) return;
  var CFG = window.KJ_CART_CFG || { freeAt: 500000, fee: 25000, wa: '923288266699' };
  var $ = function (s, el) { return (el || D).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || D).querySelectorAll(s)); };
  var money = function (c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-US'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
  var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 200); };
  var json = function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); };

  var CART = null, ADDED = null, OTHERS_OPEN = false, UPS = { handle: null, items: [], mode: '', sel: {} };
  var CTL_CACHE = {};

  /* delivery dates */
  var eta = function () {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Karachi', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var t = new Date(+parts.year, +parts.month - 1, +parts.day), after = +parts.hour >= 12;
    var add = function (d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
    var addW = function (d, n) { var x = new Date(d); while (n > 0) { x = add(x, 1); if (x.getDay() !== 0) n--; } return x; };
    var b = after ? add(t, 1) : t; while (b.getDay() === 0) b = add(b, 1);
    var a = addW(b, 3), z = addW(b, 6);
    var W = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var same = a.getMonth() === z.getMonth();
    return W[a.getDay()] + ' ' + a.getDate() + (same ? '' : ' ' + M[a.getMonth()]) + ' – ' + W[z.getDay()] + ' ' + z.getDate() + ' ' + M[z.getMonth()];
  };

  /* open / close */
  var lastFocus = null, closeT = null;
  var open = function () {
    clearTimeout(closeT);
    if (D.classList.contains('is-open')) { D.classList.add('is-in'); document.documentElement.style.overflow = 'hidden'; return; }
    lastFocus = document.activeElement;
    D.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { D.classList.add('is-in'); }); });
    setTimeout(function () { var x = $('.kjd__x'); if (x) x.focus({ preventScroll: true }); }, 320);
  };
  var close = function () {
    D.classList.remove('is-in');
    document.documentElement.style.overflow = '';
    clearTimeout(closeT);
    closeT = setTimeout(function () { D.classList.remove('is-open'); }, 300);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  };
  $$('[data-kjd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && D.classList.contains('is-open')) close(); });

  /* cart */
  var setBusy = function (on) { D.classList.toggle('is-busy', !!on); };
  var fetchCart = function () {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json).then(function (c) { CART = c; publish(); return c; });
  };
  var publish = function () {
    document.dispatchEvent(new CustomEvent('kj:cart-updated', { detail: CART }));
    $$('.js-cart-count', document).forEach(function (el) { el.textContent = CART.item_count; });
  };
  var change = function (key, qty) {
    setBusy(true);
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(json).then(function (c) { CART = c; publish(); if (ADDED && !c.items.some(function (i) { return i.key === ADDED; })) ADDED = null; render(); })
      .catch(function (err) { alertLine(err && err.description); fetchCart().then(render); })
      .then(function () { setBusy(false); });
  };
  var alertLine = function (msg) { if (!msg) return; var m = $('[data-kjd-dmsg]'); m.textContent = msg; m.className = 'kjd__dmsg is-bad'; };

  var variantText = function (it) {
    if (!it.options_with_values) return it.variant_title || '';
    return it.options_with_values.filter(function (o) { return o.value !== 'Default Title' && !/material|fabric/i.test(o.name); }).map(function (o) { return (/(size|age)/i.test(o.name) ? 'Size' : o.name) + ': ' + o.value; }).join(' · ');
  };
  var lineTotal = function (it) {
    var t = it.final_line_price; var o = it.original_line_price;
    return (o > t ? '<s>' + money(o) + '</s>' : '') + money(t);
  };
  var trash = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#6B6457" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';
  var card = function (it, label) {
    return '<div class="kjd__added">' + (label ? '<small>' + label + '</small>' : '') + '<div class="kjd__line">' +
      '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 200)) + '" alt=""></a><div>' +
      '<div class="kjd__ttl"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><button type="button" class="kjd__del" data-rm="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + '">' + trash + '</button></div>' +
      '<span class="kjd__var">' + esc(variantText(it)) + '</span>' +
      '<div class="kjd__qrow"><div class="kjd__qty"><button type="button" data-q="' + esc(it.key) + '" data-d="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + esc(it.key) + '" data-d="1" aria-label="Increase quantity">+</button></div>' +
      '<span class="kjd__lt">' + lineTotal(it) + '</span></div></div></div></div>';
  };
  var row = function (it) {
    return '<div class="kjd__orow"><img src="' + esc(img(it.image, 100)) + '" alt=""><div><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span class="kjd__var">' + esc(variantText(it)) + '</span>' +
      '<div style="display:flex;align-items:center;gap:8px"><div class="kjd__qty"><button type="button" data-q="' + esc(it.key) + '" data-d="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + esc(it.key) + '" data-d="1" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="kjd__rm" data-rm="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + '">Remove</button></div></div><b>' + money(it.final_line_price) + '</b></div>';
  };

  var render = function () {
    if (!CART) return;
    var items = CART.items || [];
    $('[data-kjd-count]').textContent = CART.item_count;
    var box = $('[data-kjd-items]');
    $('[data-kjd-ok]').classList.toggle('kj-hide', !ADDED);
    if (!items.length) {
      box.innerHTML = '<div class="kjd__empty"><b>Your cart is empty</b><button type="button" data-kjd-empty-cont>Continue shopping</button></div>';
      $('[data-kjd-empty-cont]').addEventListener('click', contShop);
    } else {
      var added = ADDED ? items.filter(function (i) { return i.key === ADDED; })[0] : null;
      if (added) {
        var others = items.filter(function (i) { return i.key !== ADDED; });
        var html = card(added, 'JUST ADDED');
        if (others.length) {
          var n = others.reduce(function (t, i) { return t + i.quantity; }, 0);
          var sum = others.reduce(function (t, i) { return t + i.final_line_price; }, 0);
          html += '<div class="kjd__others"><button type="button" class="kjd__ohead" data-kjd-otoggle aria-expanded="' + OTHERS_OPEN + '"><span class="kjd__othumbs">' +
            others.slice(0, 3).map(function (i) { return '<img src="' + esc(img(i.image, 80)) + '" alt="">'; }).join('') + '</span><span><b>Also in your cart (' + n + (n === 1 ? ' item' : ' items') + ')</b><small>' + money(sum) + ' · Tap to ' + (OTHERS_OPEN ? 'hide' : 'see all') + '</small></span>' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#17140F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></button>' +
            (OTHERS_OPEN ? '<div class="kjd__olist">' + others.map(row).join('') + '</div>' : '') + '</div>';
        }
        box.innerHTML = html;
      } else {
        box.innerHTML = items.map(function (i) { return card(i, ''); }).join('');
      }
    }
    $$('[data-q]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-q'); var it = items.filter(function (i) { return i.key === key; })[0]; if (!it) return;
        change(key, Math.max(0, it.quantity + (+b.getAttribute('data-d'))));
      });
    });
    $$('[data-rm]', box).forEach(function (b) { b.addEventListener('click', function () { change(b.getAttribute('data-rm'), 0); }); });
    var ot = $('[data-kjd-otoggle]', box); if (ot) ot.addEventListener('click', function () { OTHERS_OPEN = !OTHERS_OPEN; render(); });

    // free delivery + totals
    var sub = CART.items_subtotal_price != null ? CART.items_subtotal_price : CART.total_price;
    var total = CART.total_price;
    var free = sub >= CFG.freeAt;
    var fee = !items.length ? 0 : (free ? 0 : CFG.fee);
    var rowEl = $('[data-kjd-free-row]'), ico = $('[data-kjd-free-ico]');
    rowEl.classList.toggle('is-done', free);
    $('[data-kjd-free-msg]').textContent = free ? 'FREE DELIVERY UNLOCKED!' : 'Rs' + Math.ceil((CFG.freeAt - sub) / 100) + '/- ki aur shopping karein, GET FREE DELIVERY';
    ico.innerHTML = free ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#17140F" stroke-width="2" stroke-linejoin="round"><path d="M1 4h14v12H1z"/><path d="M15 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';
    var bar = $('[data-kjd-free-bar]');
    requestAnimationFrame(function () { bar.style.width = Math.min(100, Math.round(sub * 100 / CFG.freeAt)) + '%'; });
    var orig = CART.original_total_price || sub;
    var disc = Math.max(0, (CART.total_discount || 0));
    $('[data-kjd-sub]').textContent = money(disc ? orig : sub);
    $('[data-kjd-discrow]').classList.toggle('kj-hide', !disc);
    $('[data-kjd-disc-amt]').textContent = '− ' + money(disc);
    var feeEl = $('[data-kjd-fee]');
    feeEl.textContent = fee ? money(fee) : 'FREE';
    feeEl.className = fee ? '' : 'is-free';
    feeEl.style.fontWeight = '700';
    $('[data-kjd-total]').textContent = money(total + fee);
    $('[data-kjd-eta]').textContent = eta();
    var go = $('[data-kjd-go]');
    $('[data-kjd-go-label]').textContent = items.length ? 'COMPLETE ORDER · ' + money(total + fee) : 'COMPLETE ORDER';
    go.classList.toggle('kj-hide', !items.length);
    // continue shopping label
    var lc = null; try { lc = JSON.parse(sessionStorage.getItem('kjLastCol') || 'null'); } catch (e) {}
    var cs = $('[data-kjd-cont-sub]');
    if (lc && lc.title) { cs.textContent = 'Back to ' + lc.title; cs.classList.remove('kj-hide'); } else cs.classList.add('kj-hide');
    // discount codes
    var dm = $('[data-kjd-dmsg]');
    var codes = (CART.discount_codes || []);
    if (codes.length) {
      var c = codes[codes.length - 1];
      dm.textContent = c.applicable ? '✓ Code ' + c.code + ' applied' : 'Code ' + c.code + ' isn’t valid for these items';
      dm.className = 'kjd__dmsg ' + (c.applicable ? 'is-ok' : 'is-bad');
    }
    renderUps();
  };

  var contShop = function () {
    var lc = null; try { lc = JSON.parse(sessionStorage.getItem('kjLastCol') || 'null'); } catch (e) {}
    if (lc && lc.url && location.pathname !== lc.url.split('?')[0]) { window.location.href = lc.url; return; }
    close();
  };
  $('[data-kjd-cont]').addEventListener('click', contShop);

  /* discount code */
  var dt = $('[data-kjd-dtoggle]');
  dt.addEventListener('click', function () {
    var row = $('[data-kjd-drow]'); var show = row.classList.contains('kj-hide');
    row.classList.toggle('kj-hide', !show); dt.setAttribute('aria-expanded', show); $('[data-kjd-dlabel]').textContent = show ? 'Hide' : 'Tap here';
    if (show) setTimeout(function () { $('[data-kjd-code]').focus(); }, 50);
  });
  var applyCode = function () {
    var code = ($('[data-kjd-code]').value || '').trim();
    var dm = $('[data-kjd-dmsg]');
    if (!code) { dm.textContent = 'Please enter a code'; dm.className = 'kjd__dmsg is-bad'; return; }
    setBusy(true);
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(json).then(function (c) {
        CART = c; publish();
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        render();
        if (!hit) { dm.textContent = 'Code will be applied at checkout'; dm.className = 'kjd__dmsg is-ok'; }
      })
      .catch(function () { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname + location.search); })
      .then(function () { setBusy(false); });
  };
  $('[data-kjd-apply]').addEventListener('click', applyCode);
  $('[data-kjd-code]').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });

  /* ---------- complete the look (upsell): same cards as the collection page ---------- */
  var loadUps = function (handle, childSize) {
    if (!handle) return;
    var done = function (d) {
      UPS.handle = handle; UPS.mode = d.mode;
      var rowEl = $('[data-kjd-urow]');
      rowEl.classList.add('kjups');
      rowEl.innerHTML = d.html; rowEl.scrollLeft = 0;
      if (childSize && window.KJCards) window.KJCards.follow(rowEl, childSize);
      renderUps();
    };
    if (CTL_CACHE[handle]) return done(CTL_CACHE[handle]);
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=kj-ctl', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var box = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-kj-ctl-cards]');
        var d = { mode: box ? box.getAttribute('data-mode') : '', html: box ? box.innerHTML : '' };
        CTL_CACHE[handle] = d; done(d);
      }).catch(function () { $('[data-kjd-urow]').innerHTML = ''; renderUps(); });
  };
  var renderUps = function () {
    var wrap = $('[data-kjd-ups]'), rowEl = $('[data-kjd-urow]');
    var inCart = (CART && CART.items || []).map(function (i) { return String(i.product_id); });
    var n = 0;
    Array.prototype.forEach.call(rowEl.querySelectorAll('[data-kjc]'), function (c) {
      var justAdded = c.querySelector('.kjc__add.is-done, .kjc__add.is-loading');
      var hide = inCart.indexOf(c.getAttribute('data-id')) >= 0 && !justAdded;
      c.classList.toggle('kj-hide', hide); if (!hide) n++;
    });
    if (!n || !(CART && CART.items.length)) { wrap.classList.add('kj-hide'); return; }
    wrap.classList.remove('kj-hide');
    $('[data-kjd-ups-title]').textContent = UPS.mode === 'like' ? 'You may also like' : 'Complete the look';
  };

  /* ---------- public ---------- */
  var openWith = function (addedKey) {
    ADDED = addedKey || null; OTHERS_OPEN = false;
    open();
    setBusy(true);
    fetchCart().then(function (c) {
      render();
      var base = (ADDED && c.items.filter(function (i) { return i.key === ADDED; })[0]) || c.items[0];
      if (base) {
        var size = null;
        (base.options_with_values || []).forEach(function (o) { if (/(size|age)/i.test(o.name)) size = o.value; });
        if (UPS.handle !== base.handle) loadUps(base.handle, size); else renderUps();
      }
    }).catch(function () {}).then(function () { setBusy(false); });
  };
  window.KJCart = { open: openWith, close: close, refresh: function () { return fetchCart().then(render); } };

  document.addEventListener('kj:added', function (e) { var it = e.detail && e.detail.item; openWith(it && it.key); });

  /* header cart icon → new drawer */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-toggle-cart, .js-mini-cart, .header-cart-icon, [data-kj-open-cart]');
    if (!t || D.contains(t)) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openWith(null);
  }, true);

  /* the theme's own ajax add (quick view, collection cards, bundles) opens its mini cart: redirect to ours */
  var watch = function () {
    var mc = document.querySelector('.js-mini-cart');
    if (!mc || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (mc.classList.contains('active')) {
        mc.classList.remove('active'); document.body.classList.remove('overflow-hidden');
        fetchCart().then(function (c) { openWith(c.items[0] && c.items[0].key); });
      }
    }).observe(mc, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
